export default function reducer(
  state = {
    deletedFile: '',
  },
  action
) {
  switch (action.type) {
    case 'DELETE_FILE_STARTED': {
      return { ...state, changingStatus: 'ongoing', deletedFile: '' };
    }
    case 'DELETE_FILE_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        deletedFile: action.payload,
      };
    }
    case 'DELETE_FILE_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        deletedFile: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
